import React from 'react';
import folder from '../../assets/logos/Folder.svg';

const EmptyBenefitsState = ({ title, subtitle }) => (
  <div className="breadcrumb-report-primary-app">
    <img src={folder} alt="folder" />
    <div className="No-primary-appl">{title}</div>
    <div className="noMainAppli">
      {subtitle}
    </div>
  </div>
);

export default EmptyBenefitsState;
